import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  width: 100%;
  height: 100%;
  margin-bottom: 50px; 


  @media (max-width: 480px) {
    margin-bottom: 0px; 
    height: 90%;
  } 
`;

export const Blurb = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 80%;

  h2:hover {
    color: #b566ff;
  }
  
  h1:hover {
    color: #b566ff;
  }

  h1, h2 {
    margin: 0;
    padding: 10px;
    font-weight: 600;
  }

  h1, h2 {
    color: #000
    font-size: 30px;
  }
  
  @media (max-width: 480px) {
    h1, h2 {
      font-size: 25px;
    }
  }

`;

export const Headshot = styled.img`
  margin: 10px;
  border-radius: 50%;
  max-width: 300px;
  width: 100%;
  transition: 0.2s;
  background: #eee;

  &:hover {
    box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.18), 0 0px 12px 0 rgba(0, 0, 0, 0.15);
    opacity: 0.8;
  }

  @media (max-width: 480px) {
    max-width: 250px;
    margin: 0px;
  } 
`;